import { tv } from "@fanka/tailwind-variants";

export const SECTION_MESSAGE_CONTAINER_CLASS_NAME = tv({
  base: "border-ui-200 items-start flex gap-x-4 rounded-md border w-[484px] max-w-full",
  variants: {
    type: {
      info: "bg-functional-success-light",
      error: "bg-functional-danger-light",
      warning: "bg-functional-warn-light",
    },
    size: {
      sm: "p-3 gap-x-3",
      md: "p-4 gap-x-4",
      lg: "p-4 gap-x-4",
    },
  },
});

export const SECTION_MESSAGE_ICON_CLASS_NAME = tv({
  base: "shrink-0",
  variants: {
    type: {
      info: "fill-functional-success",
      error: "fill-functional-danger",
      warning: "fill-functional-warn",
    },
    size: {
      sm: "w-[18px] h-[18px]",
      md: "",
      lg: "",
    },
  },
});
